import { Logo, ToastContainer, FaUserAlt, FaEyeSlash, FaEye, useParams, MdLock, AiOutlineLoading3Quarters, overlayStyle, loaderStyle, } from '../../common/common'
import Navigations from '../../common/useNavigation';
import MidResetPassword from '../../middleware/Authentication/MidResetPassword'


const ResetPassword = () => {
    const { navigatePrivacyPolicy, navigateForgotPassword } = Navigations();
    
    const { handleSubmit, handleChange, values, type, handleToggle, isLoading, isDisabled, navigateprivacypolicy, useErrorContext, navigateRegisterations } = MidResetPassword();

    const { error } = useErrorContext();

    
    return (
        <div className='bg-white w-full min-h-screen flex flex-col'>
            <div className='flex-1'>
                <div className='text-center justify-center flex pt-4'>
                    <img src={Logo} width={220} height={70} alt='Logo' className='w-44 md:w-56' />
                </div>
                <div className='max-w-[360px] w-full bg-white my-0 mx-auto p-4 md:p-7' style={{ boxShadow: 'rgb(0 0 0 / 10%) 0px 0px 10px' }}>
                    <form className="form" onSubmit={handleSubmit}>

                        <div>
                            <label className='text-sm text-label-color font-semibold'>Password </label>
                            <div className={`${error.passWord ? 'bg-red-100 border-red-700 my-0' : ' bg-transparent border-border-color mb-4'} p-2 relative w-full rounded-md mt-2 border-2`}>
                                <MdLock className='text-label-color h-4 w-4 absolute left-3 top-3' />
                                <input
                                    className="bg-transparent ml-6 pl-1 focus:outline-none pr-5 w-[85%] md:w-[90%]"
                                    type={type}
                                    name="passWord"
                                    id="passWord"
                                    autoComplete="new-password"
                                    value={values.passWord}
                                    onChange={handleChange}
                                    placeholder='Enter password' />
                                {type === 'password' ? <FaEyeSlash onClick={handleToggle} className="h-4 w-4 absolute right-3 top-3 text-xs cursor-pointer" />
                                    : <FaEye onClick={handleToggle} className="h-4 w-4 absolute right-3 top-3 text-xs cursor-pointer" />}
                            </div>
                            {error.passWord && <p className='my-2 px-2 text-red-600 text-xs'>{error.passWord}</p>}
                        </div>



                        <div>
                            <label className='text-sm text-label-color font-semibold'>Confirm Password</label>
                            <div className={`${error.confirmpassWord ? 'bg-red-100 border-red-700 my-0' : ' bg-transparent border-border-color mb-4'} p-2 relative w-full rounded-md mt-2 border-2`}>
                                <MdLock className='text-label-color h-4 w-4 absolute left-3 top-3' />
                                <input
                                    className="bg-transparent ml-6 pl-1 focus:outline-none pr-5 w-[85%] md:w-[90%]"
                                    type={type}
                                    name="confirmpassWord"
                                    id="confirmpassWord"
                                    autoComplete="new-password"
                                    value={values.confirmpassWord}
                                    onChange={handleChange}
                                    placeholder='Enter Confirm PassWord' />
                                {type === 'password' ? <FaEyeSlash onClick={handleToggle} className="h-4 w-4 absolute right-3 top-3 text-xs cursor-pointer" />
                                    : <FaEye onClick={handleToggle} className="h-4 w-4 absolute right-3 top-3 text-xs cursor-pointer" />}
                            </div>
                            {error.confirmpassWord && <p className='my-2 px-2 text-red-600 text-xs'>{error.confirmpassWord}</p>}
                        </div>
                        <div>
                            <div className="text-right mt-1 mb-4">
                                <span
                                    onClick={navigateForgotPassword}
                                    className="text-sm text-blue-600 font-semibold cursor-pointer hover:underline"
                                >
                                    Back to Login
                                </span>
                            </div>

                        </div>
                        <div className="py-2 text-xs pb-4">
                            <p>By clicking below, you agree to the Selzor <span className='text-md font-semibold text-blue-500'><a href="/legal/cloud-terms-of-service" target="_blank">Cloud Terms of Service</a></span> and <span className='text-md font-semibold text-blue-500'><a href="/legal/privacy-policy" target="_blank">Privacy Policy</a></span>.</p>
                        </div>

                        {(isDisabled === true) ?
                            <button className="cursor-not-allowed opacity-80 relative group m-auto px-8 md:px-12 h-12 md:h-14 text-center rounded-full flex flex-row items-center bg-button-color hover:bg-button-color" disabled>
                                {(isLoading === true) ?
                                    <span className='flex flex-row m-auto text-md font-semibold text-black'>
                                        <AiOutlineLoading3Quarters className='animate-spin h-5 w-5 mr-3' />Processing
                                    </span> :
                                    <span className="relative text-md text-center text-black font-semibold">Change Password</span>
                                }
                                <div className="flex items-center h-10 w-10 md:h-12 md:w-12 rounded-3xl bg-button-color absolute right-[-15px] md:right-[-20px] z-20 drop-shadow-3xl">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6 stroke-black translate-x-2 md:translate-x-3 transition duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </button> :
                            <button className="relative group m-auto px-8 md:px-12 h-12 md:h-14 text-center rounded-full flex flex-row items-center bg-button-color hover:bg-button-color">
                                {(isLoading === true) ?
                                    <span className='flex flex-row m-auto text-md font-semibold text-black'>
                                        <AiOutlineLoading3Quarters className='animate-spin h-5 w-5 mr-3' />Processing
                                    </span> :
                                    <span className="relative text-md text-center text-black font-semibold">Change Password</span>
                                }
                                <div className="flex items-center h-10 w-10 md:h-12 md:w-12 rounded-3xl bg-button-color absolute right-[-15px] md:right-[-20px] z-20 drop-shadow-3xl">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 md:h-6 md:w-6 stroke-black translate-x-2 md:translate-x-3 transition duration-300 group-hover:translate-x-4 md:group-hover:translate-x-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </button>
                        }

                        <ToastContainer />
                    </form>
                    <div className='m-3 border-b-[1px] border-solid border-[#e5e5e5]'></div>
                    <div className="text-center mx-0 font-semibold">
                        <p className="py-2 text-sm">Don't Have an Account? <span className="text-blue-600 cursor-pointer text-md font-bold" onClick={navigateRegisterations}>Register Now</span></p>
                    </div>
                    <div className='mx-0 text-center mt-2 text-xs text-[#777575]'>
                        <p className='font-sm font-semibold'>This site is protected by reCAPTCHA and the <span className='text-xs text-blue-500 cursor-pointer' onClick={navigatePrivacyPolicy}>Google Privacy Policy</span> and <span className='text-xs text-blue-500 cursor-pointer'>Terms of Service apply.</span></p>
                    </div>
                </div>
            </div>

            <footer className="w-full bg-white shadow-lg mt-8 py-2">
                <div className="max-w-[1200px] mx-auto p-2">
                    {/* Links Grid */}
                    <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7 gap-2 md:gap-4 text-center">
                        <div><a href="/feature" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Features</a></div>
                        <div><a href="/price" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Price</a></div>
                        <div><a href="/application" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Application</a></div>
                        <div><a href="/blog" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Blogs</a></div>
                        <div><a href="/about" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">About</a></div>
                        <div><a href="/help" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Help</a></div>
                        <div><a href="/documentation" className="text-xs md:text-sm text-gray-700 hover:text-blue-500">Documentation</a></div>
                    </div>

                    {/* Copyright Text */}
                    <div className="text-center mt-2">
                        <p className="text-slate-400 text-xs md:text-sm">
                            &copy; Copyright. All rights Reserved {new Date().getFullYear()}
                        </p>
                    </div>
                </div>
            </footer>

            {isLoading && (
                <div style={overlayStyle}>
                    <div style={loaderStyle}>Loading...</div>
                </div>
            )}
        </div>
    )
}

export default ResetPassword